import { DirectionsBoat, Sync } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { InvoiceFormField } from "./InvoiceFormField";

export const InvoiceExchange = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <Sync style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("Exchange")}
          </div>
        }
        elements={
          <div
            style={{
              display: "flex",
              flexWrap: "wrap"
            }}
          >
            <InvoiceFormField label={t("ExchangeDate")} type="disabledDate" code="ExchangeDate" data={dataState} setData={setDataState} />
            <InvoiceFormField label={t("ExchangeType")} type="disabled" code="ExchangeType" data={dataState} setData={setDataState} />
            <InvoiceFormField label={t("Exchange")} type="disabled" code="ExchangeValue" data={dataState} setData={setDataState} />
          </div>
        }
      />
    </>
  )
}